export default function FlagIcon({color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.6209 7.66667C14.5638 7.56532 14.5338 7.45036 14.5338 7.33333C14.5338 7.21631 14.5638 7.10135 14.6209 7L15.7388 5C15.91 4.69587 16.0001 4.35086 16 3.99968C15.9999 3.6485 15.9097 3.30352 15.7385 2.99944C15.5672 2.69537 15.3209 2.44291 15.0243 2.26747C14.7277 2.09202 14.3913 1.99978 14.0489 2H3.64994C3.47756 2 3.31225 2.07024 3.19036 2.19526C3.06848 2.32029 3 2.48986 3 2.66667V17.3333C3 17.5101 3.06848 17.6797 3.19036 17.8047C3.31225 17.9298 3.47756 18 3.64994 18C3.82231 18 3.98763 17.9298 4.10951 17.8047C4.2314 17.6797 4.29987 17.5101 4.29987 17.3333V12.6667H14.0489C14.3904 12.6662 14.7257 12.5738 15.0213 12.3987C15.317 12.2236 15.5627 11.972 15.7338 11.6689C15.9049 11.3658 15.9954 11.022 15.9963 10.6718C15.9971 10.3216 15.9083 9.97729 15.7388 9.67333L14.6209 7.66667Z"
        fill={color?color: "#6C6969"}
      />
    </svg>
  );
}
